import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Tab from 'containers/User/components/Tab';
import './form.scss';

class FormRegister extends Component {
  static propTypes = {
    forms: PropTypes.arrayOf(PropTypes.shape()),
    onTabChange: PropTypes.func,
  };

  handleTabChange = () => {
    _.invoke(this.props, 'onTabChange');
  };

  render() {
    const { forms } = this.props;
    const panes = _.map(forms, ({ menuItem, form }, index) => ({
      menuItem,
      render: () => (
        <Tab.Pane className="c-form-register__pane">{form}</Tab.Pane>
      ),
    }));

    return (
      <Tab
        className="c-form-register__tabs"
        panes={panes}
        onTabChange={this.handleTabChange}
      />
    );
  }
}

export default FormRegister;
